// onCreateRegistration.ts

import { gql } from '@apollo/client';
import { onCreateRegistration } from '../subscriptions';

export const ON_CREATE_REGISTRATION = gql`${onCreateRegistration}`;